'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderRest = function () {
  function ProviderRest($http) {
    (0, _classCallCheck3.default)(this, ProviderRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      PROVIDERS_LIST: 'providers/',
      PROVIDER_DETAIL: 'providers/%1$s/'
    };
  }

  (0, _createClass3.default)(ProviderRest, [{
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.PROVIDERS_LIST, { params: params });
    }
  }, {
    key: 'getProvider',
    value: function getProvider(id) {
      return this.$http.get(this.sprintf(this.PATH.PROVIDER_DETAIL, id));
    }
  }, {
    key: 'update',
    value: function update(id, data) {
      return this.$http.put(this.sprintf(this.PATH.PROVIDER_DETAIL, id), data);
    }
  }]);
  return ProviderRest;
}();

exports.default = ProviderRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/ProviderResource.js
// module id = 322
// module chunks = 0